WiseMetering.Views.IndexLeads = WiseMetering.Views.TableIndex.extend({
    icon: 'leads',
    name: () => i18next.t('glossary.companies'),

    createTable: function() {
        return new WiseMetering.Views.Table({
            collection: WiseMetering.leads,
            disableSelect: !WiseMetering.currentUser.isSuperUser(),
            columns: {
                state: {
                    mRender: state => JST['templates/ui/components/circle']({
                        color: WiseMetering.Colors[state === 'converted' ? 'green' : 'orange']
                    }),
                    sWidth: '20px'
                },
                organization_name: i18next.t('organizations.name'),
                organization_type: i18next.t('common.type'),
                email: i18next.t('common.email'),
                telephone: i18next.t('common.telephone'),
                country: i18next.t('common.country'),
                converted_at: i18next.t('glossary.converted_at')
            },
            id: 'leads',
            toolbar_actions: {
                edit: {
                    permission: 'superuser',
                    label: 'Convert',
                    view_call: model => {
                        if (model.get('state') === 'pending') {
                            new WiseMetering.Views.LeadConvert({ model });
                        } else {
                            WiseMetering.layout.showTipper('info', 'Lead is already converted or rejected');
                        }
                    }
                }
            }
        });
    }
});
